import React, { useMemo, useState } from "react";
import Box from "../mui/Box";
import Stack from "../mui/Stack";
import DeleteIcon from "@mui/icons-material/Delete";
import Chip from "@mui/material/Chip";

import { styled } from "@mui/material/styles";
import FormControl from "../mui/FormControl";
import TextField_new from "../mui/TextField_new";
import Button from "../mui/Button";
import Grid from "../mui/Grid";
import Text from "../mui/Text";
import Typography from "../mui/Typography";
import ImageComponent from "../mui/Image";

interface AddProgramFormProps {}

const StyledLabel = styled(Box)(({ theme }) => ({
  fontSize: "14px !important",
  marginBottom: "3px !important",
  fontWeight: "500 !important",
  color: "#191919 !important",
}));

const ButtonStyle = styled(Button)(({ theme }) => ({
  border: "1px solid #997906",
  backgroundColor: "#FFF1B7",
  boxShadow: "none",
  padding: "6px 20px",
  borderRadius: "8px",
  "&:hover": {
    boxShadow: "none",
  },
}));

const BoxFlex = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "20px",
}));

const ProjectForm: React.FC<any> = ({
  error,
  validateProjectForm,
  handleOnChangeValue,
  handleOnChangeModuleValue,
  handleOnChangeSubModuleValue,
  projectsDetails,
  setError,
}) => {
  const handleAddModule = () => {
    if (!projectsDetails?.moduleName?.trim()) return;
    if (!/^[A-Za-z\s]+$/.test(projectsDetails.moduleName)) return;

    const isDuplicate = projectsDetails.modules.some(
      (value: any) => projectsDetails.moduleName === value.name
    );
    if (!isDuplicate) {
      handleOnChangeValue("modules", [
        ...projectsDetails?.modules,
        { name: projectsDetails?.moduleName, subModules: [] },
      ]);
      handleOnChangeValue("moduleName", "");
    }
  };

  const handleAddSubModule = (moduleIndex: number) => {
    const subName = projectsDetails?.subModuleName[moduleIndex];
    if (!subName?.trim()) {
      setError((prevErrors: any) => ({
        ...prevErrors,
        modules: {
          ...prevErrors,
          [moduleIndex]: "Submodule name is required.",
        },
      }));
      return;
    }
    if (!/^[A-Za-z\s]+$/.test(subName)) {
      setError((prevErrors: any) => ({
        ...prevErrors,
        modules: {
          ...prevErrors,
          [moduleIndex]: "Only letters are allowed.",
        },
      }));
      return;
    }

    const updatedModules = [...projectsDetails?.modules];
    const targetModule = updatedModules[moduleIndex];

    if (!targetModule?.subModules?.some((value: string) => subName === value)) {
      targetModule?.subModules?.push(subName);
      handleOnChangeValue("modules", updatedModules);
      handleOnChangeValue("subModuleName", { [moduleIndex]: "" });
      setError((prevErrors: any) => ({
        ...prevErrors,
        modules: {
          ...prevErrors.modules,
          [moduleIndex]: "",
        },
      }));
    }
  };

  const handleDeleteModule = (moduleIndex: number) => {
    handleOnChangeValue(
      "modules",
      projectsDetails?.modules.filter(
        (_: any, index: number) => index !== moduleIndex
      )
    );
  };

  const handleDeleteSubModule = (
    moduleIndex: number,
    subModuleIndex: number
  ) => {
    const updatedModules = [...projectsDetails?.modules];
    updatedModules[moduleIndex].subModules.splice(subModuleIndex, 1);
    handleOnChangeValue("modules", updatedModules);
  };

  const isAddButtonDisabled = useMemo(() => {
    const { moduleName } = projectsDetails;

    if (!moduleName?.trim()) {
      setError((prevErrors: any) => ({
        ...prevErrors,
        modulesName: "",
      }));
      return true;
    } else if (/\d/.test(moduleName)) {
      setError((prevErrors: any) => ({
        ...prevErrors,
        modulesName: "Module name cannot contain numbers.",
      }));
      return true;
    }

    // Clear the error message when the module name is valid
    setError((prevErrors: any) => ({
      ...prevErrors,
      modulesName: "",
    }));
    return false;
  }, [projectsDetails.moduleName]);

  return (
    <Stack direction="column">
      {/* Project Name Field */}
      <StyledLabel sx={{ fontWeight: "600 !important" }}>
        Project Name
      </StyledLabel>
      <FormControl
        fullWidth
        sx={{ borderBottom: "1px solid #BEBEBE", paddingBottom: "12px" }}
      >
        <TextField_new
          // name="projectName"
          placeholder="Enter Project Name"
          value={projectsDetails.projectName}
          onChange={(e: any) => {
            handleOnChangeValue("projectName", e.target.value);
          }}
          // onChange={(e:any)=>handleOnChangeValue("projectName",e.target.value)}
        />
        <Text sx={{ color: "red", fontSize: "13px", marginTop: "-12px" }}>
          {error.projectName}
        </Text>
      </FormControl>

      {/* Module Name Field */}
      <StyledLabel sx={{ fontWeight: "600 !important", paddingTop: "12px" , mb:10 }}>
        Module Name
      </StyledLabel>
      <FormControl fullWidth>
        <BoxFlex sx={{ alignItems: "flex-start" }}>
          <TextField_new
            placeholder="Enter Module Name"
            value={projectsDetails?.moduleName}
            // onChange={(e: any) => {
            //   setModuleName(e.target.value);
            // }}
            onChange={(e: any) =>
              handleOnChangeValue("moduleName", e.target.value)
            }
            error={error?.moduleName !== ""}
            // helperText={error?.moduleName || ""}
            // onChange={(e:any)=>handleOnChangeModuleValue("moduleName",e.target.value)}
          />
          <ButtonStyle
            onClick={handleAddModule}
            disabled={isAddButtonDisabled}
          >
            Add
          </ButtonStyle>
        </BoxFlex>
        <Text sx={{ color: "red", fontSize: "13px", bottom:"-5px", position:"absolute" }}>
          {error.modulesName}
        </Text>
      </FormControl>

      {/* Module Name in Submodule Field */}
      {projectsDetails.modules.map((module: any, moduleIndex: number) => (
        <Box
          key={moduleIndex}
          sx={{
            backgroundColor: "#fff8d7",
            p: 2,
            border: "1px solid #997906",
            borderRadius: "5px",
            marginBlock: "10px",
            mt:2
          }}
        >
          <StyledLabel
            sx={{
              fontWeight: "600 !important",
              borderBottom: "1px solid #D0D0D0",
              fontSize: "1.1rem !important",
              marginBottom: "10px !important",
              pb: 1,
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                // "& .css-1wzdcbs": {
                //   width: "10% !important",
                // },
              }}
            >
              {module.name}
              {
                <Box sx={{ display: "flex", gap: "5px" }}>
                  <ImageComponent
                    src={"assets/images/login/Delete.svg"}
                    sx={{ cursor: "pointer", height: "22px", width: "22px" }}
                    onClick={() => handleDeleteModule(moduleIndex)}
                  />
                </Box>
              }
            </Box>
          </StyledLabel>

          {/* Submodule Field */}
          <StyledLabel>Submodule</StyledLabel>
          {/* <StyledLabel sx={{ color: "red" }}>{error?.modules?.[moduleIndex]}</StyledLabel> */}
          <FormControl fullWidth>
            <BoxFlex sx={{ alignItems: "flex-start" }}>
              <TextField_new
                placeholder="Enter Submodule Name"
                value={projectsDetails?.subModuleName[moduleIndex] || ""}
                onChange={(e: any) =>
                  handleOnChangeValue(
                    "subModuleName",
                    e.target.value,
                    moduleIndex
                  )
                }
                error={error?.modules?.[moduleIndex]?.length > 0}
                helperText={error?.modules?.[moduleIndex]}
              />
              <ButtonStyle onClick={() => handleAddSubModule(moduleIndex)}>
                Add
              </ButtonStyle>
            </BoxFlex>
          </FormControl>

          {/* Submodule Chips */}
          <Grid container spacing={1} mt={1}>
            {/* Iterate over modules */}
            <Grid container spacing={1}>
              {module?.subModules && module?.subModules?.length > 0
                ? module?.subModules.map(
                    (subModule: string, subModuleIndex: number) => (
                      <Grid item key={subModuleIndex}>
                        <Chip
                          label={subModule}
                          sx={{
                            backgroundColor: "#FFF1B7",
                            color: "black",
                          }}
                          onDelete={() =>
                            handleDeleteSubModule(moduleIndex, subModuleIndex)
                          }
                        />
                      </Grid>
                    )
                  )
                : null}
            </Grid>
          </Grid>
        </Box>
      ))}
    </Stack>
  );
};

export default ProjectForm;
